import { CRM_OBJECT_SUMMARY } from '../../constants/Tools';
import { parseObjectId } from '../../utils/parserUtils';

/**
 * Converts a legacy Object Summary action to a V2 compatible format
 * @param inAppActionLegacy The legacy action to convert
 * @returns The converted action in V2 format
 */
export const convertFeedbackSubmissionSummaryAction = inAppActionLegacy => {
  var _inAppActionLegacy$pr;
  const extractedObjectId = Number(parseObjectId((_inAppActionLegacy$pr = inAppActionLegacy.property_filters) === null || _inAppActionLegacy$pr === void 0 || (_inAppActionLegacy$pr = _inAppActionLegacy$pr[0]) === null || _inAppActionLegacy$pr === void 0 ? void 0 : _inAppActionLegacy$pr.value)) || 0;
  return {
    name: CRM_OBJECT_SUMMARY,
    arguments: {
      '@type': 'map',
      value: {
        // TODO - `summaryFormat` - handle since V1 does not support that data
        // Default to STANDARD since legacy doesn't specify
        summaryFormat: {
          '@type': 'string',
          value: 'STANDARD'
        },
        summaryType: {
          '@type': 'string',
          value: 'FEEDBACK_SUBMISSION'
        },
        // TODO - `propertiesToInclude` - handle since V1 does not support that data
        // Legacy action doesn't support propertiesToInclude
        propertiesToInclude: {
          '@type': 'list',
          value: []
        },
        // TODO - `objectQuery` - handle since V1 does not have a 1:1 mapping to this V2 field
        query: extractedObjectId !== 0 ? {
          '@type': 'string',
          value: `${inAppActionLegacy.text} with objectId ${extractedObjectId}`
        } : undefined,
        customInstructions: inAppActionLegacy.context ? {
          '@type': 'string',
          value: Object.entries(inAppActionLegacy.context).map(([key, value]) => `${key}: ${value}`).join(', ')
        } : undefined,
        propertyFilters: inAppActionLegacy.property_filters ? {
          '@type': 'list',
          value: inAppActionLegacy.property_filters.map(filter => {
            var _filter$property;
            return {
              '@type': 'map',
              value: {
                property: {
                  '@type': 'string',
                  value: typeof filter.property === 'string' ? filter.property : ((_filter$property = filter.property) === null || _filter$property === void 0 ? void 0 : _filter$property.property_name) || ''
                },
                operator: {
                  '@type': 'string',
                  value: typeof filter.operator === 'string' ? filter.operator : filter.operator || 'EQ'
                },
                value: filter.value && typeof filter.value === 'string' ? {
                  '@type': 'string',
                  value: filter.value
                } : undefined,
                highValue: filter.high_value && typeof filter.high_value === 'string' ? {
                  '@type': 'string',
                  value: filter.high_value
                } : undefined,
                values: filter.values && Array.isArray(filter.values) ? {
                  '@type': 'list',
                  value: filter.values.filter(v => typeof v === 'string')
                } : undefined
              }
            };
          })
        } : undefined,
        objectCoordinates: {
          '@type': 'map',
          value: {
            objectId: {
              '@type': 'long',
              value: extractedObjectId
            },
            objectTypeId: {
              '@type': 'map',
              value: {
                innerId: {
                  '@type': 'integer',
                  value: 111 // Based on FEEDBACK_SURVEY objectTypeId => 0-111
                },
                metaType: {
                  '@type': 'string',
                  value: 'HUBSPOT'
                }
              }
            }
          }
        }
      }
    }
  };
};